import Head from 'next/head';
import React from 'react';
import { ArticlesList } from '../components';
import { withLayout } from '../Layout/Layout';

function TopLists() {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/dining`} />
        <meta
          name="description"
          content={
            "Savor the world's finest cuisines with First-Class.com. Explore dining articles, reviews, and culinary delights from around the globe"
          }
        />
        <title>Dining: Culinary Experiences for Discerning Tastes</title>
      </Head>
      <ArticlesList type="Dining" heading="Dining" />
    </>
  );
}

export default withLayout(TopLists, true);
